const ipfsExtractor = (link) => {
    const IPFS_URI = 'https://ipfs.io/ipfs/'
    return `${IPFS_URI}${link.replace('ipfs://','')}`;
} 

export default ipfsExtractor;